import {
  REACTION_EXCLUDE_SECTIONS,
  REACTIONS_CUTOFF_UTC,
  SHOW_REACTIONS,
} from "@config/reactions";

export function shouldShowReactions(
  publishDate: string,
  uniqueSectionName?: string,
): boolean {
  if (!SHOW_REACTIONS) return false;

  const cutoff = new Date(REACTIONS_CUTOFF_UTC);
  const createdDate = new Date(publishDate);

  // If article is older than cutoff, hide reactions
  if (createdDate < cutoff) return false;

  if (!uniqueSectionName) return true; // no section to check

  return !REACTION_EXCLUDE_SECTIONS.includes(uniqueSectionName.toLowerCase());
}
